import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import ReactGA from 'react-ga';
import {Helmet} from "react-helmet";
// import StickyHeader from '../../components/onboarding/StickyHeader';
import WishlistReviewProduct from '../../components/wishlist/WishlistReviewProduct';

import './ReviewedProducts.css';

import Api from '../../utils/api';

class ReviewedProducts extends Component {
    constructor(props){
        super(props);

        this.products = [];

        this.state = {
            reviewedProducts: []
        }

        this.syncProducts = this.syncProducts.bind(this);
        this.handleCheckout = this.handleCheckout.bind(this);
    }

    componentWillMount() {
        const userId = localStorage.getItem("user_id");
        if (userId) {
            this.getReviewedProducts();
            this.checkIfPreviouslyPurchased();
            this.checkIfPaidGateFee();
        } else {
            // localStorage.setItem('visited_recommendations', true);
            this.props.history.push('/signin');
        }
    }

    getReviewedProducts() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/reviewed-products?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({ 
                reviewedProducts: responseJson ? responseJson : [] });
        }).catch(function(err) {
            alert("There was a problem getting your wishlist. Please refresh the page and try again.");
        });
    
    }

    checkIfPreviouslyPurchased() {
        const userId = localStorage.getItem("user_id");

        fetch('/api/user-orders/extended-with-products?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            if (responseJson && responseJson.length < 1) this.setState({ hasNeverPurchased: true });
            else this.setState({ hasNeverPurchased: false });
        }).catch(function(err) {
            alert("There is a problem to get the orders. Please try again.");
        });
    }

    checkIfPaidGateFee() {
        const userId = localStorage.getItem("user_id"); 
        fetch('/api/user-flags/gate-fee-paid?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => response.json()).then(responseJson => {
            if (responseJson) {
                this.setState({ userPaidGateFee: true });
            }
        })
        .catch(function(err) {
            alert("There was a problem getting the confirmation code. Please try again.");
        });
    }

    syncProducts(prev, curr) {
        let arr = this.products;
        let i = arr.indexOf(prev);

        if(i !== -1){
            arr.splice(i, 1);
        }

        if(curr.indexOf(":0") === -1) {
            arr.push(curr);
        }

        this.products = arr;
    }

    handleCheckout() {
        const count = this.products.reduce((res, val) => res + parseInt(val.split(":")[1],10), 0);
        if (count <= 0) {
            alert("You must select at least one product.");
            return;
        }

        let url = "";
        if (this.state.userPaidGateFee) {
            if (this.state.hasNeverPurchased) {
                url = 'https://helloava.myshopify.com/cart/' + this.products.toString() + '?discount=curationfeepurchasecredit10';
             } else {
                url = 'https://helloava.myshopify.com/cart/' + this.products.toString();
             }
        } else {
            url = 'https://helloava.myshopify.com/cart/' + this.products.toString();
        }
        window.open(url);
        // if (process.env.REACT_APP_ENV === 'prod') {
        //     ReactGA.event({
        //         category: 'Checkout Funnel',
        //         action: 'Click',
        //         label: 'Checkout',
        //         value: 1
        //     });
        // }
    }


    render() {
        const reviewedProducts = this.state.reviewedProducts;
        let productReviewsStream = reviewedProducts.map(product => {
            return(
                <div className="reviewed-product">
                    <WishlistReviewProduct 
                        product={product}
                        page={2}
                        syncProducts={ this.syncProducts }
                    />
                </div>
            );
        });

        return (
            <div id="wishlist">
            <Helmet>
                <title>Reviewed Products - HelloAva</title>
            </Helmet>
                {/*<div id="links">
                    <div id="links-section" className="links-section">
                        <StickyHeader
                            height={51} 
                            page="right" 
                            left="WISHLIST" 
                            right="REVIEWED PRODUCTS"
                            leftLink="/wishlist"
                            rightLink="/reviewed-products"
                        />
                    </div>
                </div>*/}
                <div id="reviewed-products-section" className="reviewed-products-section">
                        <div className="reviewed-products-body">
                            {productReviewsStream}
                        </div>
                </div>

                <div className="checkout-section">
                    <button className="view-my-recommendations-button" onClick={this.handleCheckout}>Check out</button>
                </div>
               

            </div>
        );
    }
}

export default withRouter(ReviewedProducts);



// WEBPACK FOOTER //
// ./src/views/reviewedproducts/ReviewedProducts.js